import BillingTable from "./BillingTable";

export default BillingTable;